// extracted by mini-css-extract-plugin
module.exports = {"sequenceDisplay":"SequenceDisplay_sequenceDisplay__gIWlA","errorMessage":"SequenceDisplay_errorMessage__nLZyS","loadingMessage":"SequenceDisplay_loadingMessage__F_0zZ"};